import apiRequest from 'Utils/apiRequest'

export default {
  getCourseContentModules(courseId, page) {
    return apiRequest.get(
      `/school/course/${courseId}/module/?type=courseContent`,
      {
        params: { page },
      }
    )
  },
  getAllCourseModules(courseId) {
    return apiRequest.get(`/school/course/${courseId}/module/?type=all`)
  },
  updateModuleOrder(courseId, orderArray) {
    return apiRequest.patch(
      `/school/course/${courseId}/module/?type=updateOrder`,
      {
        newOrder: orderArray,
      }
    )
  },
  toggleCurrentModule(moduleId) {
    return apiRequest.post(`/school/module/${moduleId}/?type=toggleCurrent`)
  },
  toggleTrialVisible(moduleId) {
    return apiRequest.post(
      `/school/module/${moduleId}/?type=toggleTrialVisible`
    )
  },
  getLandingPageModules(courseId, page) {
    return apiRequest.get(`/school/course/${courseId}/module/?type=landing`, {
      params: { page },
    })
  },
  editModule(moduleId, m) {
    return apiRequest.patch(`/school/module/${moduleId}/`, m)
  },
  deleteModule(moduleId) {
    return apiRequest.delete(`/school/module/${moduleId}/`)
  },
  createModule(courseId, m) {
    return apiRequest.put(`/school/course/${courseId}/module/`, m)
  },
  getDetail(moduleId) {
    return apiRequest.get(`/school/module/${moduleId}/`)
  },
}
